import React from 'react';
import { Star } from 'lucide-react';

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="bg-slate-900 rounded-xl shadow-lg p-6 border border-slate-700 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-[#fd5a27]/20 hover:border-[#fd5a27]">
      <div className="flex items-center mb-4">
        <img
          src={testimonial.image}
          alt={testimonial.name}
          className="w-16 h-16 rounded-full object-cover mr-4"
        />
        <div>
          <h4 className="font-bold text-white">{testimonial.name}</h4>
          <p className="text-sm text-gray-300">{testimonial.role}</p>
        </div>
      </div>
      
      <div className="flex mb-3">
        {[...Array(testimonial.rating)].map((_, i) => (
          <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
        ))}
      </div>
      
      <p className="text-gray-200 text-sm leading-relaxed">{testimonial.text}</p>
    </div>
  );
};

export default TestimonialCard;
